import { Button, Card } from "@ui/shad"
import { ArrowRight, Workflow } from "lucide-react"

import { useActionLink } from "@/hooks/api/action-links"
import { Link } from "@/components/book-link"

export default function AutomationHandoff({ id }: { id: string }) {
  const { data: actionLink } = useActionLink(id)

  if (!actionLink) return null

  const title = typeof actionLink.properties?.title === "string" ? actionLink.properties.title : "Create an automation"
  const prompt = typeof actionLink.properties?.prompt === "string" ? actionLink.properties.prompt : undefined
  const isExpired = new Date(actionLink.expires_at) < new Date()
  const isExecuted = !!actionLink.executed_at
  const href =
    isExpired || isExecuted
      ? "/automations/new?chat=open"
      : `/automations/new?chat=open&handoff=${encodeURIComponent(id)}`

  return (
    <Card className="mt-2 w-full max-w-xl space-y-3 p-4">
      <div className="flex items-start gap-3">
        <Workflow className="text-blue-foreground mt-0.5 size-5 shrink-0" />
        <div className="min-w-0">
          <p className="font-medium">{title}</p>
          <p className="text-muted-foreground text-sm">
            {isExecuted
              ? "Continue reviewing this draft in Automation Chat."
              : "Automation Chat will validate the request and help you build the draft."}
          </p>
        </div>
      </div>
      {prompt && <p className="bg-tinted rounded-md p-3 text-sm break-words whitespace-pre-wrap">{prompt}</p>}
      <Button asChild size="sm">
        <Link href={href}>
          {isExecuted ? "Open automation draft" : "Continue in Automation Chat"}
          <ArrowRight />
        </Link>
      </Button>
    </Card>
  )
}
